export default "__VITE_ASSET__1NjdbW$Y__"